<script lang="ts">
  import type { StandardSearchResult } from '$lib/pinecone/types';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';
  import HeadingSizeDecorator from '$components/Common/HeadingSizeDecorator.svelte';

  interface Props {
    results: StandardSearchResult[];
  }

  let { results }: Props = $props();

  function truncateText(text: string, maxLength: number = 150): string {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + '...';
  }
</script>

<div class="search-results">
  <ul>
    {#each results as result, i}
      <li>
        <a href={result.url} target="_blank" rel="noopener noreferrer">
          <h6 class="search-result-title">
            <HeadingSizeDecorator size="h6">
              {result.title}
            </HeadingSizeDecorator>
          </h6>
          <p class="search-result-text">
            <FontSizeDecorator size="caption">
              {truncateText(result.text)}
            </FontSizeDecorator>
          </p>
        </a>
      </li>
      {#if i < results.length - 1}
        <div class="search-item-divider"></div>
      {/if}
    {/each}
  </ul>
</div>

<style lang="scss">
  @import 'src/scss/variables';

  .search-results {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: block;
        padding: 12px;
        border-radius: 8px;
        transition: background-color 0.2s ease;
        color: $text-default-color;

        &:hover,
        &:focus-within {
          background: $background-depth-1-hover-color;
        }
        a {
          text-decoration: none;
          color: inherit;

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  .search-result-title {
    margin: 0 0 8px;
  }

  .search-result-text {
    margin: 0;
    color: $text-helper-color;
  }

  .search-item-divider {
    border-top: 1px solid $border-depth-2-color;
    margin: 8px 12px;
  }
</style>
